import React from 'react';
import IconBase from './IconBase';
const ChevronRightIcon = props => React.createElement(IconBase, props, React.createElement("g", null, React.createElement("defs", null, React.createElement("polygon", {
  points: "-507,-1597.791 -508.209,-1599 -513,-1594.209 -517.791,-1599 -519,-1597.791 -514.209,-1593 -519,-1588.209 -517.791,-1587 -513,-1591.791 -508.209,-1587 -507,-1588.209 -511.791,-1593 \t\t"
})), React.createElement("g", null, React.createElement("defs", null, React.createElement("rect", {
  x: "-688",
  y: "-3317",
  width: "1440",
  height: "6698"
})))), React.createElement("g", null, React.createElement("polyline", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "18.205,58.04 43.767,32.478 18.205,6.916 \t"
})));
ChevronRightIcon.displayName = 'ChevronRightIcon';
export default ChevronRightIcon;
//# sourceMappingURL=ChevronRightIcon.js.map